<script lang="ts">
	import { onMount } from 'svelte';
	import { Text, Input, Container, Loader } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';
	import ImageList from '../../../Lists/ImageList.svelte';
	import { getImages, getImagesByType } from '../../../Lists/list-helpers';
	import { _deepClone, capFirstChar } from '../../../../helpers/utilities';
	import type { ISceneObj } from '../../../../types/SceneType';

	export let scene_object: ISceneObj;

	let uploadedImagesDB = [];
	let imagesBySceneType = [];
	let inputRef: HTMLElement;
	let inputDirty = false;

	const requestType = 'scene';

	const downloadImages = async () => {
		uploadedImagesDB = await getImages(requestType);
		imagesBySceneType = await getImagesByType(requestType, null);
	};

	// Image List Functions - on images actions
	const onSelectImage = (e: CustomEvent) => {
		scene_object._meta.image = e?.detail?.image;
		scene_object._meta.backgroundColor = e?.detail?.backgroundColor;
	};

	const onUploadImage = (e: CustomEvent) => {
		onSelectImage(e);
		uploadedImagesDB = [...e.detail.uploadedImagesDB];
	};

	const onInput = (e) => {
		if (!inputDirty) inputDirty = true;
		scene_object._meta.name = e.target.value;
	};

	onMount(() => {
		//TODO input focus should be set when Main step is active
		// if (inputRef) inputRef.focus();
	});
</script>

<Container noScroll padding="scrollPaddings">
	<Text element="h2" class="mb-s"
		>{capFirstChar(
			$format('placeholder_name', {
				values: { type: $format('process_scene') },
			}),
		)}</Text
	>
	<Input
		icon="fas fa-film"
		label={$format('label_name', { default: 'name' })}
		value={scene_object?._meta?.name}
		error={scene_object?._meta?.name === '' && inputDirty
			? $format('input_error_empty_name', {
					default: 'Name cannot be empty',
				})
			: ''}
		bind:ref={inputRef}
		on:input={onInput}
		id="input-pjtp0cl"
		aria-labelledby="input-pjtp0cl"
	/>

	<hr class="mt-l mb-l" />
</Container>

<Container noScroll padding="scrollPaddings">
	<Text element="h2" class="mb-m">
		{capFirstChar($format('select_picture', { default: 'Select picture' }))}
	</Text>

	{#await downloadImages()}
		<div class="d-flex justify-content-center">
			<Loader />
		</div>
	{:then}
		<ImageList
			{uploadedImagesDB}
			imagesByTypeDB={imagesBySceneType}
			selectedImage={scene_object._meta.image}
			selectedBackgroundColor={scene_object._meta.backgroundColor}
			setDefaultImage={!scene_object._meta.image && !scene_object._meta.backgroundColor}
			requestType={'scene'}
			on:select-image={onSelectImage}
			on:upload-image={onUploadImage}
		/>
	{/await}
</Container>
